import React from 'react';

import { useFeatureServices } from './use-feature-services';
import { QSGContext } from './use-qsg-context';

import _ from 'lodash';
import {
  FeatureAppTrackingEvent,
  FeatureAppTrackingManager,
  TrackingEvent,
} from '../typings/tagging';

export function getDefaultTrackingEvent(lang: string = 'en'): FeatureAppTrackingEvent {
  return {
    eventInfo: {
      pageName: 'Quick Start Guide',
      pageCategory: 'Quick Start Guide',
    },
    environment: {
      featureAppIdAppVersion: process.env.APPVERSION,
      featureAppId: 'QuickStartGuide-D6-US',
      language: lang,
    },
  };
}

function buildTrackingEvent(
  cusTrackEvent?: FeatureAppTrackingEvent,
  lang: string = 'en'
): FeatureAppTrackingEvent {
  let trackingEvent: FeatureAppTrackingEvent;

  if (cusTrackEvent) {
    trackingEvent = _.cloneDeep(cusTrackEvent);
    
    if (!trackingEvent.environment) 
      trackingEvent.environment = {};
    
    if (!trackingEvent.environment.language) 
      trackingEvent.environment.language = lang;
    
  } else {
    trackingEvent = _.cloneDeep(getDefaultTrackingEvent(lang));
  }

  return trackingEvent;
}

export function getTrackEventClone(lang: string = 'en'): FeatureAppTrackingEvent {
  return _.cloneDeep(getDefaultTrackingEvent(lang));
}

export function useTrackingManager(): FeatureAppTrackingManager {
  const trackingManager = useFeatureServices()['tracking']!;
  const qsgContext = React.useContext(QSGContext);
  
  const lang = qsgContext?.lang?.value || 'en';

  return React.useMemo((): FeatureAppTrackingManager => {
    function track(action: string, event: FeatureAppTrackingEvent): void {
      if (trackingManager) {
        trackingManager.track(action, event as unknown as TrackingEvent);
      }
    }
    return {
      trackQSGGlobalEvent(
        event: string,
        trackEvent?: FeatureAppTrackingEvent
      ): void {
        track(event, buildTrackingEvent(trackEvent, lang));
      },
    };
  }, [trackingManager, lang]);
}
